const BASE_URL = 'https://www.zola.com';

export default [
  {
    question: 'Is there wedding seating chart etiquette?',
    answer: `As you plan your wedding seating chart, there are a few considerations to keep in mind. Our biggest tip? Keep your guests' personalities and interests top of mind! Check out even more of our <a href="${BASE_URL}/expert-advice/how-to-create-a-wedding-seating-chart">seating chart tips</a>.`,
  },
  {
    question: 'How do I organize my wedding reception tables?',
    answer:
      "It's a good idea to group wedding guests based on what you think they'll enjoy the most during your reception! Sometimes that means seating family or friend groups together, while other times it means pairing people together who may not have met before but have a lot in common. Zola's seating chart maker makes it easy to create a custom floor plan based on your venue's specifications!",
  },
  {
    question: 'How should I organize my wedding ceremony seating?',
    answer:
      'There are many ways you can configure your wedding ceremony seating chart, but typically, VIPs like parents, grandparents, close family, and the wedding party sit in the first two rows.',
  },
  {
    question: 'Do you provide a wedding seating chart template?',
    answer:
      "Yes! We'll ask you for some basic info, like the number and size/shape of all your tables, then we'll place them around a dance floor for you to start. You can customize anything you want from there!",
  },
  {
    question: 'Is there wedding seating chart etiquette?',
    answer: `Having a clear floor plan for your wedding will help everything run much more smoothly! And with Zola's seating chart maker, you can quickly and easily seat all your guests and have a layout to share with your wedding planner and venue. Pro tip: having a seating chart also makes it easier to organize your <a href="${BASE_URL}/wedding-planning/place-cards/shop">place cards</a>.`,
  },
  {
    question: 'Can I print my seating chart template and create a poster to display at my wedding?',
    answer:
      "Yes! You can export a PDF of all your wedding guests' names and table numbers to have printed. ",
  },
];
